module.exports = __webpack_public_path__ + "static/img/5.fa49433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/5.png
// module id = 80xr
// module chunks = 0